var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"floating-uploader",style:({
    left: _vm.adjustedPosition.x + 'px',
    top: _vm.adjustedPosition.y + 'px'
  })},[_c('Uploader',{attrs:{"width":"40px","height":"40px","disabled":_vm.readonly,"label":"Image","icon":"add_photo_alternate","value":_vm.currentImage},on:{"input":_vm.onImageUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }